import React from 'react';
import { useTranslation } from 'react-i18next';

import SidebarLiftup from '../News/SidebarLiftup';

import Faqs from './Faqs';
import Loading from '../Common/Loading';
import Box from '../Common/Box';
import SubMenu from '../Common/SubMenu';
import BackButton from '../Common/BackButton';
import AnonHeader from '../Common/AnonHeader';

// Actions.
import { fetchFaqs } from '../../actions';
// Types.
import { HubSpotDB } from '../../types/faq';
import { SimpleUser } from '../../types/customer';
// Utils.
import { gaPageviewIfAllowed } from '../../utils/googleAnalytics';

type CustomerServiceProps = {
  activeUser: SimpleUser;
};

const Faq: React.FunctionComponent<CustomerServiceProps> = (props: CustomerServiceProps) => {
  const { t } = useTranslation();
  const [faqs, setFaqs] = React.useState<HubSpotDB[]>();
  const { endpoint } = props.activeUser;
  const [pageview, setPageview] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!pageview) {
      gaPageviewIfAllowed('/faq');
      setPageview(true);
    }
  }, [pageview]);

  let openFaq = '';
  if (window.location.pathname.split('/').length >= 3) {
    openFaq = window.location.pathname.split('/')[2];
  }

  React.useEffect(() => {
    // Create an scoped async function in the hook
    async function fetchAvailableFaqs(): Promise<void> {
      const faqs = await fetchFaqs();

      setFaqs(faqs);
    }
    // Execute the created function directly
    fetchAvailableFaqs();
  }, []);

  const contactInformation = (
    <Box size="third" noStyles>
      <Box>
        <SidebarLiftup />
      </Box>
    </Box>
  );

  const categories: { [key: string]: Array<HubSpotDB> } = {};
  const categoryShouldOpen: { [key: string]: boolean } = {};

  if (faqs) {
    faqs.map((faq) => {
      if (faq && faq.values.category) {
        faq.values.category.map((category) => {
          if (!categories[category.name]) {
            categories[category.name] = [];
          }
          categories[category.name].push(faq);
          if (openFaq !== '') {
            if (t(`customerService:faq.${openFaq}`) === category.name) {
              categoryShouldOpen[category.name] = true;
            } else {
              categoryShouldOpen[category.name] = false;
            }
          }
          return false;
        });
      }
      return false;
    });
  }

  const sortedQuestions: Array<React.JSX.Element> = [];
  for (const category in categories) {
    sortedQuestions.push(
      <Faqs key={category} category={category} questions={categories[category]} categoryShouldBeOpen={categoryShouldOpen[category]} />,
    );
  }

  return (
    <Box wrapper size={endpoint !== 'anon' ? 'double' : 'anon'}>
      <Box size={endpoint !== 'anon' ? 'twoThirds' : 'anon'}>
        {endpoint !== 'anon' && <SubMenu />}
        {endpoint === 'anon' && <AnonHeader />}
        {endpoint === 'anon' && <BackButton />}
        <h1 aria-live="polite"> {t('customerService:faq.faqTitle')} </h1>
        <p> {t('customerService:faq.faqIngress')} </p>

        {sortedQuestions.length > 0 ? sortedQuestions : <Loading />}
      </Box>

      {endpoint !== 'anon' && contactInformation}
    </Box>
  );
};

export default Faq;
